<template>
  <div
    class="colored-sticker"
    :class="sClass"
    :style="sStyle"
    :data-id="sticker.id"
    @click="clickSticker"
    @touchend="clickSticker"
  >
    <textarea
      v-show="displayTextarea"
      ref="textarea"
      v-model="sticker.text"
      @blur="blurTextarea"
    />
    <div v-show="!displayTextarea" ref="content" class="content">
      {{ sticker.text }}
    </div>
  </div>
</template>

<script>

import $ from 'jquery';
import { SET_STICKER } from '@/store/action-types';

export default {

  name: 'Sticker',

  props: {
    sticker: {
      type: Object,
      required: true,
    },
    container: {
      type: HTMLElement,
      required: true,
    },
    phpParams: {
      type: Object,
      default: () => ({}),
    },
    zIndex: {
      type: Number,
      default: 1,
    },
    maxZIndex: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      colors: ['yellow', 'fuschia', 'red', 'orange', 'green', 'blue'],
      displayTextarea: false,
      isDragging: false,
      saving: false,
    };
  },

  computed: {
    sClass() {
      return this.colors[this.sticker.color || 0];
    },
    sStyle() {
      return {
        position: 'absolute',
        left: `${this.sticker.x}%`,
        top: `${this.sticker.y}%`,
        width: `${this.sticker.width}%`,
        height: `${this.sticker.height}%`,
        zIndex: (this.isDragging || this.displayTextarea || this.saving) ? this.maxZIndex : this.zIndex,
      };
    },
    rect() {
      return {
        x: Number(this.sticker.x),
        y: Number(this.sticker.y),
        width: Number(this.sticker.width),
        height: Number(this.sticker.height),
      };
    },
  },

  mounted() {
    this.initDragging();
    $(window).on(`resizeEnd.${this.uuid}`, this.initDragging);
  },

  beforeDestroy() {
    let inst = $(this.$el).draggable('instance');
    if (inst) {
      $(this.$el).draggable('destroy');
    }
    inst = $(this.$el).resizable('instance');
    if (inst) {
      $(this.$el).resizable('destroy');
    }
    $(this.$el).off('resize');
  },

  methods: {
    /** Setup drag and drop for stickers */
    initDragging() {
      let xMult;
      let yMult;
      const { offsetWidth, offsetHeight } = this.container;
      // Alow moving stickers around and editing them
      // Listen to drag (to move) and click (to edit)
      $(this.$el).draggable({
        distance: 20,
        addClasses: false,
        start: (e) => {
          xMult = 100 / offsetWidth;
          yMult = 100 / offsetHeight;
          this.$emit('drag-start');
          this.isDragging = true;
        },
        stop: (e, ui) => {
          this.$emit('drag-end');
          this.sticker.x = ui.position.left * xMult;
          this.sticker.y = ui.position.top * yMult;
          this.$nextTick(this.edit);
          setTimeout(() => { this.isDragging = false, 100 });
        },
      });
      $(this.$el).resizable({
        handles: 'se',
        start: (e) => {
          xMult = 100 / offsetWidth;
          yMult = 100 / offsetHeight;
          this.isDragging = true;
        },
        stop: (e, ui) => {
          this.sticker.width = ui.size.width * xMult;
          this.sticker.height = ui.size.height * yMult;
          this.$nextTick(this.edit);
          setTimeout(() => { this.isDragging = false, 100 });
        },
      });
      // Stop propagation on resize or it will trigger reisze on window (and fire resizeEnd)
      $(this.$el).on('resize', (e) => {
        e.stopPropagation();
      });
    },
    clickSticker() {
      if (!this.isDragging) {
        this.displayTextarea = true;
        this.$nextTick(() => {
          this.$refs.textarea.focus();
        });
      }
    },
    blurTextarea() {
      this.displayTextarea = false;
      this.edit();
    },
    edit() {
      this.saving = true;
      this.$store.dispatch(SET_STICKER, {
        ...this.phpParams,
        id: this.sticker.id,
        text: this.sticker.text,
        rect: this.rect,
        color: this.sticker.color,
      })
        .then(() => {
          this.saving = false;
          this.$emit('edit');
        });
    },
  },
};
</script>
